import React, { useEffect, useState } from "react"
import CarrotClient from "carrot-api"
import { CenteredLoadingIndicator } from "components/views/molecules/Molecules"
import { useBodyClass } from "utils/Hooks"
import { RegisterError } from "components/views/fle/register/RegisterError"
import Settings from "utils/CarrotConfig"
import { NiceToSeeYou } from "components/views/fle/register/NiceToSeeYou"
import { FinancialSupport } from "components/views/fle/register/FinancialSupport"
import { Answers } from "components/views/fle/register/Answers"
import { Access } from "components/views/fle/register/Access"
import { SetPassword } from "components/views/fle/register/SetPassword"
import { AcknowledgeTerms } from "components/views/fle/register/AcknowledgeTerms"
import { HealthConsent } from "components/views/fle/register/HealthConsent"
import { EmailOptIn } from "./EmailOptIn"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)

const RegisterWizard = (props) => {
  const LOADING = 0
  const [step, setStep] = useState(LOADING)
  const [firstName, setFirstName] = useState(null)
  const [guid, setGuid] = useState(null)
  const [email, setEmail] = useState(null)
  const [emailOptIn, setEmailOptIn] = useState(false)
  const [companyName, setCompanyName] = useState(null)
  const [coveragePercent, setCoveragePercent] = useState(null)
  const [coverageAmount, setCoverageAmount] = useState(null)
  const [currencySymbol, setCurrencySymbol] = useState(null)
  const [carrotLite, setCarrotLite] = useState(null)
  const [password, setPassword] = useState(null)
  const [readPolicy, setReadPolicy] = useState(false)
  const [readTerms, setReadTerms] = useState(false)
  const [healthConsent, setHealthConsent] = useState(false)
  const [requiresSaml, setRequiresSaml] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [benefitConfiguration, setBenefitConfiguration] = useState(null)

  useBodyClass("bg-warm-gray")

  useEffect(() => {
    async function fetchRegisteringUser() {
      const guidFromParams = props.match.params.guid
      setGuid(guidFromParams)
      const registeringUser = await client.getRegisteringUser(guidFromParams)
      if (!registeringUser) {
        setStep(9)
        return
      }

      setFirstName(registeringUser.firstName)
      setEmail(registeringUser.email)
      setCompanyName(registeringUser.companyName)
      setCoverageAmount(registeringUser.coverageAmount)
      setCoveragePercent(registeringUser.coveragePercent)
      setCurrencySymbol(registeringUser.currencySymbol)
      setCarrotLite(registeringUser.carrotLite)
      setRequiresSaml(registeringUser.requiresSaml)
      setBenefitConfiguration(registeringUser.benefitConfiguration)
      setStep(1)
    }
    fetchRegisteringUser()
  }, [props.match.params.guid])

  async function createUser() {
    try {
      setIsSubmitting(true)
      await client.createAccount(guid, password, emailOptIn, readTerms && readPolicy && healthConsent)
    } catch {
      window.location.href = "/"
    }
    window.location.href = "/fle/about-you"
  }

  function onCompleteSetPassword(password) {
    setPassword(password)
    setStep(6)
  }

  switch (step) {
    case 1:
      return (
        <NiceToSeeYou companyName={companyName} firstName={firstName} onComplete={() => setStep(carrotLite ? 3 : 2)} />
      )
    case 2:
      return (
        <FinancialSupport
          companyName={companyName}
          coverageAmount={coverageAmount}
          coveragePercent={coveragePercent}
          currencySymbol={currencySymbol}
          onBack={() => setStep(1)}
          onComplete={() => setStep(3)}
        />
      )
    case 3:
      return (
        <Answers
          onBack={() => setStep(carrotLite ? 1 : 2)}
          onComplete={() => setStep(4)}
          benefitConfiguration={benefitConfiguration}
        />
      )
    case 4:
      return <Access onBack={() => setStep(3)} onComplete={() => setStep(requiresSaml ? 6 : 5)} />
    case 5:
      return <SetPassword email={email} onBack={() => setStep(4)} onComplete={onCompleteSetPassword} />
    case 6:
      return (
        <AcknowledgeTerms
          readPolicy={readPolicy}
          setReadPolicy={setReadPolicy}
          readTerms={readTerms}
          setReadTerms={setReadTerms}
          onBack={() => setStep(requiresSaml ? 4 : 5)}
          onComplete={() => setStep(7)}
          benefitConfiguration={benefitConfiguration}
        />
      )
    case 7:
      return (
        <HealthConsent
          isSubmitting={isSubmitting}
          healthConsent={healthConsent}
          setHealthConsent={setHealthConsent}
          benefitConfiguration={benefitConfiguration}
          onBack={() => setStep(6)}
          onComplete={() => setStep(8)}
        />
      )
    case 8:
      return (
        <EmailOptIn
          emailOptIn={emailOptIn}
          setEmailOptIn={setEmailOptIn}
          benefitConfiguration={benefitConfiguration}
          onBack={() => setStep(7)}
          onComplete={createUser}
        />
      )
    case 9:
      return <RegisterError />
    default:
      return (
        <div className="vh-100 flex items-center justify-center">
          <CenteredLoadingIndicator />
        </div>
      )
  }
}

export default RegisterWizard
